import * as React from 'react'
import { Dispatch } from 'redux'
import { connect } from 'react-redux'
import NotificationDialog from './NotificationDialog'
import { State } from '../model'
import * as actions from '../model/ui/actions'

type Props = {
  notification: NotificationWithId
  onClose: (id: string) => any
}

function NotificationComponent(props: Props) {
  const handleClose = () => {
    props.onClose(props.notification.id)
  }

  const { notification } = props
  return (
    <NotificationDialog
      level={notification.level}
      title={notification.title}
      message={notification.message}
      buttonLabel="OK"
      onClose={handleClose}
    />
  )
}

export type Notification = {
  level: string
  title: string
  message: string
}

export type NotificationWithId = Notification & { id: string }

interface INotificationContainer {
  children: React.ReactNode
  dispatch: Dispatch
  notifications: NotificationWithId[]
}

function NotificationContainer(props: INotificationContainer) {
  const handleNotificationClose = (id: string) => {
    props.dispatch(actions.closeNotification(id))
  }

  return (
    <div className="notifications" style={{ height: '100%' }}>
      {props.notifications.map((notification) => {
        return (
          <NotificationComponent
            key={notification.id}
            notification={notification}
            onClose={handleNotificationClose}
          />
        )
      })}
      {props.children}
    </div>
  )
}

export default connect((state: State) => {
  return {
    notifications: state.ui.notifications,
  }
})(NotificationContainer)
